export interface MovementEvent {
	firstPointX: number;
	firstPointY: number;

	currentPointX: number;
	currentPointY: number;

	/**
	 * POSITIVE: Swipe from right to left.
	 * NEGATIVE: Swipe from left to right.
	 */
	distanceX: number;

	/**
	 * POSITIVE: Swipe from right to left.
	 * NEGATIVE: Swipe from left to right.
	 */
	percentageX: number;

	timestamp: number;
}

export enum MovementEndKey {
	SWIPED_LEFT_TO_RIGHT = -1,
	SWIPED_NEUTRAL = 0,
	SWIPED_RIGHT_TO_LEFT = +1,
}
